import { createContext } from 'react';

const StatsContext = createContext(null);

export default StatsContext;
